import React, {Component} from 'react';
import LangContext from "../../providers/LangContext";

let osmb = null;
let lmap = null;

// <script src="{{asset('js/leaflet-073.min.js')}}" defer></script>
// <script src="{{asset('js/osmbuildings-leaflet.js')}}" defer></script>

class LegacyZonneGrensContainer extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);

        this.map = React.createRef();

        this.state = {
            now: new Date().toISOString(),
            startDate: new Date(),
            didRender: false,
            dateRangeLabel: '',
            timeRangeLabel: ''
        };

        this.changeDate = this.changeDate.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.getDate = this.getDate.bind(this);
        this.getDayOfYear = this.getDayOfYear.bind(this);
        this.scriptLoaded = this.scriptLoaded.bind(this);
        this.pad = this.pad.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        return false;
    }

    componentDidMount() {
        const leafletScript = document.createElement("script");
        const osmBuildingScript = document.createElement("script");
        leafletScript.src = "/js/leaflet-073.min.js";
        leafletScript.async = false;
        document.body.appendChild(leafletScript);

        osmBuildingScript.src = "/js/osmbuildings-leaflet.js";
        osmBuildingScript.async = false;
        osmBuildingScript.onload = () => this.scriptLoaded();
        document.body.appendChild(osmBuildingScript);
    }

    scriptLoaded() {

        if (!this.props.latLng || undefined === OSMBuildings) {
            return;
        }

        const center = this.props.latLng.split(',');

        lmap = new window.L.Map(this.map.current);
        lmap.setView([parseFloat(center[0]), parseFloat(center[1])], 19, false);

        new window.L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: `${this.props.theme === 'era' ? '' : '&copy; <a href="https://homeshow.eu">HomeShow</a> | '}&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>`,
            maxZoom: 20,
            minZoom: 18,
            maxNativeZoom: 20
        }).addTo(lmap);

        const hsIcon = (this.props.theme === 'era' ?
            window.L.icon({
                iconUrl: '/images/mapsicon_era.svg',
                iconSize: [40, 69], // size of the icon
                iconAnchor: [20, 69],
                popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
            })
            :
            window.L.icon({
                iconUrl: '/images/homeshowico.png',
                iconSize: [40, 69], // size of the icon
                iconAnchor: [20, 69],
                popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
            })
        );

        window.L.marker([parseFloat(center[0]), parseFloat(center[1])], {icon: hsIcon}).addTo(lmap);
        osmb = new OSMBuildings(lmap).load('https://{s}.data.osmbuildings.org/0.2/hswphomeshow.nhdqxpxn/tile/{z}/{x}/{y}.json');
        this.changeDate()
    }

    getDate() {
        return new Date(this.state.now);
    }

    componentWillUnmount() {
        lmap.remove();
        osmb = null;
    }

    getDate() {
        return new Date(this.state.now);
    }

    changeDate() {
        let d = this.getDate();
        let Y = d.getFullYear(),
            M = d.getMonth(),
            D = d.getDate(),
            h = d.getHours(),
            m = 0;


        this.setState({
            timeRangeLabel: this.pad(h) + ':' + this.pad(m),
            dateRangeLabel: this.pad(D) + '-' + this.pad(M + 1) + '-' + Y
        });
        osmb.date(new Date(Y, M, D, h, m));
    }

    onTimeChange({target}) {

        let newNow = new Date(this.state.now);
        newNow.setHours(target.value);
        newNow.setMinutes(0);
        this.setState({now: newNow.toISOString()}, () => this.changeDate());
    }

    onDateChange({target}) {
        let newNow = new Date(this.state.now);
        newNow.setMonth(0);
        newNow.setDate(target.value);
        this.setState({now: newNow.toISOString()}, () => this.changeDate());
    }

    getDayOfYear(date) {
        let start = new Date(date.getFullYear(), 0, 0);
        let diff = (date - start) + ((start.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000);
        let oneDay = 1000 * 60 * 60 * 24;
        let day = Math.floor(diff / oneDay);
        return day;
    }

    pad(v) {
        return (v < 10 ? '0' : '') + v;
    }


    render() {
        let lang = this.context.lang;
        return(
            <div style={{position: 'relative'}}>
                <div id="map" ref={this.map}></div>
                <div className="time-control">
                    <div className="row">
                        <div className="col-3 mt-1 text-right">
                            <label htmlFor="date">{lang.get('portal.date')}:</label>
                        </div>
                        <div className="col-6">
                            <input onChange={this.onDateChange}
                                   defaultValue={this.getDayOfYear(this.state.startDate)} id="date" type="range" min="1"
                                   max="365" step="1"/>
                        </div>
                        <div className="col-3 mt-1 p-0 p-md-2">
                            <label>{this.state.dateRangeLabel}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 mt-1 text-right">
                            <label htmlFor="time">{lang.get('portal.time')}:</label>
                        </div>
                        <div className="col-6">
                            <input onChange={this.onTimeChange}
                                   defaultValue={this.state.startDate.getHours()} id="time" type="range" min="0"
                                   max="23"
                                   step="1"/>
                        </div>
                        <div className="col-3 mt-1 text-left p-0 p-md-2">
                            <label>{this.state.timeRangeLabel}</label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LegacyZonneGrensContainer;
